import AddCalendarButton from './AddCalendarButton';

export const reconnectGoogleCalendar = () => {
  return <AddCalendarButton reconnect />;
};
